import { SafeSuspense } from '@calendly/safe-suspense'
import { lazy, memo } from 'react'

export const preload = () => import(/* webpackChunkName: 'color_field' */'./component')

const ColorField = lazy(preload)

export default memo((props) => (
  <SafeSuspense>
    <ColorField {...props} />
  </SafeSuspense>
))
